import $ from 'jquery';
import enumList from 'web/utils/enumList';
import {DataTableComponent} from 'web/components/CommonComponent';

export const useDepartmentListModal = (baseComponent, departmentList) => {
  const prepareDepartmentListTable = () => {
    // 定義資料內容
    const dataSet = departmentList.map((departmentItem) => {
      return [
        departmentItem.departmentCode,
        departmentItem.departmentName,
        departmentItem.createTime,
        departmentItem.createUser,
        departmentItem.flgStatus,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '部門編號',
        className: 'dt-center',
        data: 0,
      },
      {title: '部門名稱', className: 'dt-center', data: 1},
      {
        title: '建立時間',
        className: 'dt-head-center',
        data: 2,
        render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'),
        type: 'datetime',
      },
      {title: '建立者', className: 'dt-center', data: 3},
      {
        orderable: false,
        order: null,
        title: '啟用',
        data: 4,
        className: 'dt-center',
        render: (data, type, row, meta) => {
          const enableId = 'eab-department-' + meta.row;
          const isChecked = data === enumList.flgStatus.active ? 'checked' : '';
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.department,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                              <label class="form-check-label" for="${enableId}"></label>
                          </div>`;
        },
      },
      {
        title: '編輯',
        className: 'dt-center',
        orderable: false,
        render: (data, type, row, meta) => {
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<button type="button" 
                                 class="btn btn-sm btn-link ${enableButton} w-100 flex justify-center items-center"
                                 id="edit-department-${meta.row}">
                                <svg class="btn__icon 
                                  btn__icon--sm me-1" aria-hidden="true">
                                    <use href="#ico-edit"></use>
                                </svg>
                                修改
                            </button>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      // idx: 1,
      // dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };
    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__departmentList')) {
      $('#datatable__departmentList').empty();
      $('#datatable__departmentList').DataTable().destroy();
    }

    return DataTableComponent(
      '#datatable__departmentList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
    );
  };

  return {prepareDepartmentListTable};
};
